import { call, put, takeEvery } from "redux-saga/effects";

import {
  CONTACTS_LIST,
  CONTACTS_FILTER,
  CONTACTS_CREATE,
  CONTACTS_UPDATE,
  CONTACTS_DELETE
} from "./actionTypes";

import {
 contactsListSuccess,
 contactsCreateSuccess,
 contactsUpdateSuccess,
 contactsDeleteSuccess,
 contactsRequestFailed,
} from "./actions";

import {
  getContactsList,
  getContactsFilter,
  postContactsCreate,
  patchContactsUpdate,
  deleteContacts,
} from "../../helpers/backend";

function*contactsListSaga() {
  console.log("Trayendo lista de contacts...");
  try {
    const response = yield call(getContactsList);
    if (response.status === 200) {
      yield put(contactsListSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    console.error("Error en contactsListSaga:", error);
    const errorData = error.data || error.response?.data || error.message || "Error desconocido al obtener la lista de contactos";
    yield put(contactsRequestFailed(errorData));
  }
}

function*contactsCreateSaga({ payload:contacts }) {
  console.log("Creando nuevo contacts...");
  try {
    const response = yield call(postContactsCreate,contacts);
    if (response.status === 201) {
      yield put(contactsCreateSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    console.error("Error en contactsCreateSaga:", error);
    let errorData;

    // api.js interceptor rejects with {status, data, message} (flat structure)
    const errData = error.data || error.response?.data;
    const errStatus = error.status || error.response?.status;

    if (errData) {
      errorData = errData;
    } else if (errStatus) {
      switch (errStatus) {
        case 400:
          errorData = { general: "Datos inválidos. Por favor revise la información ingresada." };
          break;
        case 403:
          errorData = { general: "No tiene permisos para realizar esta acción." };
          break;
        case 409:
          errorData = { general: "El usuario ya existe. Por favor use un correo electrónico diferente." };
          break;
        case 422:
          errorData = { general: "Error de validación. Verifique que todos los campos requeridos estén completos." };
          break;
        case 500:
          errorData = { general: "Error interno del servidor. Por favor intente nuevamente." };
          break;
        default:
          errorData = { general: `Error del servidor (${errStatus}). Por favor intente nuevamente.` };
      }
    } else {
      errorData = { general: "Error de conexión. Por favor verifique su conexión a internet e intente nuevamente." };
    }

    yield put(contactsRequestFailed(errorData));
  }
}

function*contactsFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getContactsFilter, { changeUrl });
    if (response.status === 200) {
      yield put(contactsListSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    console.error("Error en contactsFilterSaga:", error);
    const errorData = error.data || error.response?.data || error.message || "Error desconocido al filtrar contactos";
    yield put(contactsRequestFailed(errorData));
  }
}

function*contactsUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del CONTACTS...");
  try {
    const response = yield call(patchContactsUpdate, { id }, data);
    if (response.status === 200) {
      yield put(contactsUpdateSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    console.error("Error en contactsUpdateSaga:", error);
    let errorData;

    const errData = error.data || error.response?.data;
    const errStatus = error.status || error.response?.status;

    if (errData) {
      errorData = errData;
    } else if (errStatus) {
      switch (errStatus) {
        case 400:
          errorData = { general: "Datos inválidos para la actualización." };
          break;
        case 403:
          errorData = { general: "No tiene permisos para realizar esta acción." };
          break;
        case 404:
          errorData = { general: "Usuario no encontrado." };
          break;
        case 422:
          errorData = { general: "Error de validación en la actualización." };
          break;
        case 500:
          errorData = { general: "Error interno del servidor al actualizar." };
          break;
        default:
          errorData = { general: `Error del servidor (${errStatus}) al actualizar.` };
      }
    } else {
      errorData = { general: "Error de conexión al actualizar el usuario." };
    }

    yield put(contactsRequestFailed(errorData));
  }
}

function*contactsDeleteSaga({ payload: { id } }) {
  console.log("Eliminando contacto...");
  try {
    const response = yield call(deleteContacts, id );
    if (response.status === 204) {
      yield put(contactsDeleteSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    console.error("Error en contactsDeleteSaga:", error);
    let errorData;

    const errData = error.data || error.response?.data;
    const errStatus = error.status || error.response?.status;

    if (errData) {
      errorData = errData;
    } else if (errStatus) {
      switch (errStatus) {
        case 404:
          errorData = { general: "Usuario no encontrado para eliminar." };
          break;
        case 403:
          errorData = { general: "No tiene permisos para eliminar este usuario." };
          break;
        case 500:
          errorData = { general: "Error interno del servidor al eliminar." };
          break;
        default:
          errorData = { general: `Error del servidor (${errStatus}) al eliminar.` };
      }
    } else {
      errorData = { general: "Error de conexión al eliminar el usuario." };
    }

    yield put(contactsRequestFailed(errorData));
  }
}

export default function*contactsSaga() {
  yield takeEvery(CONTACTS_LIST,contactsListSaga);
  yield takeEvery(CONTACTS_FILTER,contactsFilterSaga);
  yield takeEvery(CONTACTS_CREATE,contactsCreateSaga);
  yield takeEvery(CONTACTS_UPDATE,contactsUpdateSaga);
  yield takeEvery(CONTACTS_DELETE,contactsDeleteSaga);
}
